import type React from "react";

import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Paper,
  BottomNavigation,
  BottomNavigationAction,
} from "@mui/material";
import {
  LayoutDashboard,
  Contact,
  Handshake,
  BookText,
  Users,
  Menu,
} from "lucide-react";
import { ACTIVE_COLOR } from "@/constants/color";

interface NavItem {
  key: string;
  label: string;
  path: string;
  icon: React.ReactNode;
}

const navItems: NavItem[] = [
  {
    key: "dashboard",
    label: "Tablero",
    path: "/home",
    icon: <LayoutDashboard size={24} />,
  },
  {
    key: "leads",
    label: "Contactos",
    path: "/leads",
    icon: <Contact size={24} />,
  },
  {
    key: "deals",
    label: "Tratos",
    path: "/deals",
    icon: <Handshake size={24} />,
  },
  {
    key: "menu",
    label: "",
    path: "/menu",
    icon: <Menu size={24} />,
  },
];

export default function MobileNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const [value, setValue] = useState(0);

  useEffect(() => {
    const currentIndex = navItems.findIndex((item) =>
      location.pathname.startsWith(item.path)
    );
    if (currentIndex !== -1) {
      setValue(currentIndex);
    }
  }, [location.pathname]);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    navigate(navItems[newValue].path);
  };

  return (
    <Box
      sx={{
        width: "100%",
        position: "fixed", // sigue fijo
        bottom: 0,
        left: 0,
        zIndex: 1000,
        paddingBottom: "env(safe-area-inset-bottom)", // evita que se superponga al notch
        bgcolor: "background.paper", // asegura que tenga fondo
      }}
    >
      <Paper elevation={3} sx={{ borderRadius: "12px 12px 0 0" }}>
        <BottomNavigation
          value={value}
          onChange={handleChange}
          showLabels
          sx={{
            height: 64,
            "& .MuiBottomNavigationAction-root": {
              color: "text.secondary",
              "&.Mui-selected": {
                borderTop: 2,
                color: ACTIVE_COLOR,
              },
            },
          }}
        >
          {navItems.map((item, index) => (
            <BottomNavigationAction
              key={index}
              label={item.label}
              icon={item.icon}
              sx={{
                "& .MuiBottomNavigationAction-label": {
                  mt: 1,
                  fontSize: "0.75rem",
                  transition: "font-size 0.2s",
                  "&.Mui-selected": {
                    fontSize: "0.75rem",
                    color: ACTIVE_COLOR,
                  },
                },
              }}
            />
          ))}
        </BottomNavigation>
      </Paper>
    </Box>
  );
}
